import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import type { ProccesedWallets } from '@/modules/networks/hooks/use-wallets-card';
import { WALLETS_TABLE_COLUMNS, type WalletsTableColumn } from '@/modules/networks/lib/constants';
import { SortEnum } from '@/modules/networks/types';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
interface UseWalletsTableProps {
  wallets: ProccesedWallets[];
}
export function useWalletsTable(t0) {
  const $ = _c(17);
  const {
    wallets
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = WALLETS_TABLE_COLUMNS.map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [headersSort, setHeadersSort] = useState(t1);
  const [sortColumn, setSortColumn] = useState(-1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      from: "lg"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isDesktop = useMediaQuery(t2);
  let t3;
  if ($[2] !== isDesktop) {
    t3 = WALLETS_TABLE_COLUMNS.map(column_0 => ({
      accessorKey: column_0.accessorKey,
      hasSort: column_0.hasSort,
      sortReverse: column_0.sortReverse,
      isNumeric: column_0.isNumeric,
      header: !isDesktop && column_0.shortHeader ? column_0.shortHeader : column_0.header
    }));
    $[2] = isDesktop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const proccesedWalletsTableColumns = t3;
  let t4;
  if ($[4] !== headersSort) {
    t4 = index => {
      const sortNeutralState = WALLETS_TABLE_COLUMNS.map(_temp2) as SortEnum[];
      if (headersSort[index] === SortEnum.Neutral) {
        if (WALLETS_TABLE_COLUMNS[index].sortReverse) {
          sortNeutralState[index] = SortEnum.Desc;
        } else {
          sortNeutralState[index] = SortEnum.Asc;
        }
      } else {
        sortNeutralState[index] = headersSort[index] === SortEnum.Asc ? SortEnum.Desc : SortEnum.Asc;
      }
      setHeadersSort(sortNeutralState);
      setSortColumn(index);
    };
    $[4] = headersSort;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSortClick = t4;
  const handleRowClick = _temp3;
  let t5;
  if ($[6] !== headersSort || $[7] !== sortColumn) {
    t5 = wallets_0 => {
      if (sortColumn === -1) {
        return wallets_0;
      }
      const column_2 = WALLETS_TABLE_COLUMNS[sortColumn];
      const sortDirection = headersSort[sortColumn];
      if (sortDirection === SortEnum.Neutral || sortDirection === SortEnum.Disabled) {
        return wallets_0;
      }
      return [...wallets_0].sort((a, b) => {
        const aValue = a[column_2.accessorKey as keyof ProccesedWallets];
        const bValue = b[column_2.accessorKey as keyof ProccesedWallets];
        if (aValue < bValue) {
          return sortDirection === SortEnum.Asc ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortDirection === SortEnum.Asc ? 1 : -1;
        }
        return 0;
      });
    };
    $[6] = headersSort;
    $[7] = sortColumn;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const sortWallets = t5;
  let t6;
  if ($[9] !== sortWallets || $[10] !== wallets) {
    t6 = sortWallets(wallets);
    $[9] = sortWallets;
    $[10] = wallets;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const sortedWallets = t6;
  let t7;
  if ($[12] !== handleSortClick || $[13] !== headersSort || $[14] !== proccesedWalletsTableColumns || $[15] !== sortedWallets) {
    t7 = {
      proccesedWalletsTableColumns,
      headersSort,
      sortedWallets,
      handleSortClick,
      handleRowClick
    };
    $[12] = handleSortClick;
    $[13] = headersSort;
    $[14] = proccesedWalletsTableColumns;
    $[15] = sortedWallets;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp3(event, address) {
  if (!(event.target instanceof HTMLAnchorElement)) {
    window.open(`https://etherscan.io/address/${address}`, "_blank");
  }
}
function _temp2(column_1) {
  return column_1.hasSort ? SortEnum.Neutral : SortEnum.Disabled;
}
function _temp(column) {
  return column.hasSort ? SortEnum.Neutral : SortEnum.Disabled;
}